<template>
  <div class="components-list-courses mb-2" :class="[cols.col]" :id="'itemId'+item.id">
    <!-- @mouseover="getDetiels(item)" @mouseleave="clearDetiels" -->
    <div class="panel-card mb-3">
      <router-link
        :to="'/courses/'+item.en_category +'/'+ item.en_subcategory +'/'+ item.id + '/' + item.course_title_en"
        class="d-block"
        target="_blank"
      >
        <!-- <b-popover ref="popover" :target="'itemId'+item.id" :triggers="'hover focus'" v-if="!isMobile">
          <quick-view/>
        </b-popover>-->
        <figure class="wrapper-image" :data-image="image">
          <img :src="image" :alt="item.course_title">
          <div
            v-if="item"
            class="image"
            :style="{ backgroundImage: `url('${image}')` }"
            :title="item.course_title"
          ></div>
        </figure>
        <div class="card-body px-0 py-2">
          <h4 class="text-right font-14 rtl">{{item.course_title , 60 | truncate }}</h4>
          <p class="card-content text-right rtl" v-if="item.fullname">مدرس : {{item.fullname}}</p>
          <div class="d-flex flex-column justify-content-center align-items-center">
            <div class="form-action form-action-center clearfix">
              <star-rating
                class="d-inline-block"
                :rtl="true"
                :read-only="true"
                :star-size="13"
                :show-rating="false"
                :increment="0.01"
                v-model="item.rate"
                :active-color="'#f4c150'"
                :rounded-corners="false"
                :inactive-color="'#ccc'"
              />
              <p class="info-rating d-inline-block rtl text-right">
                {{Math.round(item.rate*10)/10}}
                <!-- <span>(20)</span> -->
              </p>
            </div>

            <div class="box-price text-left clearfix" v-if="item.course_price">
              <span class="cash">{{item.course_price | currency}}</span>
              <span class="discount" v-if="false">20000</span>
            </div>
            <div class="box-price text-left clearfix" v-if="!item.course_price">
              <span class="cash">
                <i>رایگان</i>
              </span>
            </div>
          </div>
        </div>
      </router-link>
      <div class="form-action text-center">
        <div data-balloon-pos="up" data-balloon="اضافه به سبد خرید" v-if="item.course_price != 0">
          <i class="flaticon-add-to-cart icon-35" @click="addBasketCart(item)"></i>
        </div>
        <div data-balloon-pos="up" data-balloon="اضافه به لیست دوره های من" v-else>
          <i class="flaticon-list-2 icon-35" @click="startEnroll(item)"></i>
        </div>
      </div>
    </div>
    <span class="row" v-if="!item">
      <div class="col-4" v-for="(item,index) in 8" :key="index">
        <content-loader :height="570" :speed="2" :animate="true"></content-loader>
      </div>
    </span>
  </div>
</template>
<script>
import quickView from "cp/min-component/quick-view-box.vue";

export default {
  name: "list-course",
  props: {
    image: {
      type: String,
      default: ""
    },
    cols: {
      type: Object,
      default: () => { },
      required: false
    },
    item: {
      type: Object,
      default: () => { }
    },
    isFave: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    quickView
  },
  computed: {
    styles() {
      return { "background-image": "url(" + this.image + " )" };
    },
    // image () {
    //   return this.appUrl.media + '/' + this.item.Img
    // },
    windowWidth() {
      return this.$store.state.layout.windowWidth;
    },
    isMobile() {
      return this.windowWidth < 992;
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },

  data() {
    return {
      showPopperParentVar: false
    };
  },

  methods: {
    hover() { },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    async getDetiels(item) {
      // if (!this.$store.state.courses.id) {
      await this.$store.dispatch("courses/getCourseDetail", {
        id: item.id,
        getBio: true
      });
      // }
    },
    clearDetiels() {
      this.$store.commit("courses/clearSomeDetail");
    },
    async startEnroll(item) {
      if (!this.isLogin) {
        this.$store.commit("auth/setRedirect", false);
        this.showModalLogin();
        return;
      }
      this.$store.dispatch("courses/startEnroll", item);
    }
  },
  mounted() { }
};
</script>

<style lang="less" scoped>
@import (reference) "../assets/css/variable.less";

.components-list-courses {
  position: relative;
  .wrapper-image {
    display: block;
    width: 100%;
    padding-top: 77.5555%;
    position: relative;
    overflow: hidden;
    img {
      position: absolute;
    }
    .image {
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background-position: 50%;
      background-size: cover;
    }
  }
  .panel-card {
    padding: 10px 10px 15px 10px;
    @media screen and (max-width: 768px) {
      padding: 5px 5px 10px 5px;
    }
  }
  .form-action {
    height: 35px;

    i {
      color: @green;
      transition: color 0.3s ease-in;
      &:hover {
        color: @blue;
      }
    }
  }
  .btn-favorite {
    background: transparent;
    border: none;
    cursor: pointer;
    i {
      transition: transform 200ms ease-in-out, box-shadow 400ms ease-in;
      color: @red;
      &:before {
        font-size: 24px;
      }
    }
    &:hover {
      i {
        transform: scale(1.3);
      }
    }
  }
  h4 {
    display: inline-block;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    font-weight: 600;
    height: 36px;
    min-height: 42px;
    font-size: 15px;
    color: #29303b;
    margin-bottom: 10px;
    @media screen and (max-width: 768px) {
      font-size: 12px !important;
      margin-bottom: 5px;
    }
  }
  .card-content {
    min-height: 21px;
    height: 21px;
    margin-bottom: 10px;
    font-size: 12px;
    color: #686f7a;
    padding-left: 7px;
    @media screen and (max-width: 768px) {
      margin-bottom: 5px;
    }
    .elips;
    * {
      .elips;
    }
  }
  .card-img-top {
    height: 190px;
  }
  .box-price {
    span {
      display: inline-block;
      i {
        font-size: 12px;
      }
    }
    .discount {
      color: #686f7a;
      font-weight: 400;
      font-size: 13px;
      margin-right: 5px;
      text-decoration: line-through;
    }
    .cash {
      color: #29303b;
      font-size: 18px;
      font-weight: 600;
      margin-right: 10px;
    }
  }
  .info-rating {
    font-weight: 600;
    color: #505763;
    span {
      font-size: 12px;
      font-weight: 400;
      color: #686f7a;
      margin-left: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/list-course.vue